import queries from "Shared/queries";
import { useLazyQuery } from "@apollo/client";
import React from "react";
import { GetEmployeeDisbursementsQuery, GetEmployeeDisbursementsQueryVariables } from "generated/graphql";

const useDisbursements = (employeeProfileId: string, skip = false) => {
  const [page, setPage] = React.useState(1);
  const rowsPerPage = parseInt(
    process.env.REACT_APP_DISBURSEMENTS_ROWS_PER_PAGE!,
    10
  );
  const [fetchDisbursements, { data, refetch, loading }] = useLazyQuery<
    GetEmployeeDisbursementsQuery,
    GetEmployeeDisbursementsQueryVariables
  >(
    queries.GET_EMPLOYEE_DISBURSEMENTS,
    {
      variables: {
        employeeProfileId,
        page,
        perPage: rowsPerPage
      }
    }
  );

  const refetchQueries = () => {
    if (!skip && refetch) {
      return refetch({ employeeProfileId, page });
    }
  };

  React.useEffect(() => {
    if (skip) return;

    if (refetch) {
      refetch({ employeeProfileId, page });
    } else {
      fetchDisbursements();
    }
  }, [page, employeeProfileId, refetch, skip, fetchDisbursements]);

  return { data, refetchQueries, loading, page, setPage, rowsPerPage };
};
export default useDisbursements;
